import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ReactNode } from 'react';

interface ButtonArrangeProps {
	justify?: 'space-between' | 'center';
	children: ReactNode;
}

export function ButtonArrange({ justify, children }: ButtonArrangeProps) {
	return (
		<Flex
			gap={tokens.spacing.x2}
			breakpointSmallAndUp={{
				direction: 'row',
				justify: justify ?? 'flex-end',
			}}
		>
			{children}
		</Flex>
	);
}
